import { Stack, Text } from '@mantine/core';
import type { FC } from 'react';

import { PinInput } from '../../../components/reactHookFormMantine/PinInput.tsx';
import type { FormInputsContent } from '../../FormInputsContent.ts';
import type { FormCodeVerification } from './schema.ts';

export const CodeVerification: FC<FormInputsContent<FormCodeVerification>> = ({ useFormValue: { control } }) => {
  return (
    <Stack align="center" gap="sm">
      <Text>Code</Text>
      <PinInput control={control} length={6} name="code" size="lg" />
    </Stack>
  );
};
